import { HttpClient } from "@angular/common/http";
import { Directive, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import { UIService } from "../../services/ui/ui.service";
import { NotificationElement } from "../../interfaces/notification-element";

@Directive()
export abstract class NotificationBase {
  @Input("notification") notification: NotificationElement;
  @Output() actionPerformed: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  constructor(
    protected router: Router,
    protected http: HttpClient,
    protected uiService: UIService,
  ) {}

  getNotificationUrl(): string {
    let url: string = this.notification.content.url;
    return url ? url : "#";
  }

  performAction(event: MouseEvent): void {
    const url: string = this.getNotificationUrl();
    const url_type: "default" | "external" | "ajax" =
      this.notification.content.url_type;

    const shouldIntercept = url === "#" || url_type !== "external";

    if (shouldIntercept) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (url !== "#") {
        const parsedUrl = new URL(url, window.location.origin);
        parsedUrl.searchParams.delete("topicId");
        const queryParams: Record<string, string> = {};
        parsedUrl.searchParams.forEach((value, key) => {
          queryParams[key] = value;
        });

        if (url_type === "ajax") {
          this.http.get(parsedUrl.pathname);
        } else {
          this.router.navigate([parsedUrl.pathname], {
            queryParams,
          });
        }
      }
    }

    this.handleReadState(event);

    if (this.notification.id === "unread-notifications") {
      this.uiService.notificationsPanelToggle$.next();
    }

    this.actionPerformed.emit(true);
  }

  protected handleReadState(event: MouseEvent): void {}
}
